import React, { Component } from 'react'
import { getToken, getExpiresIn } from '../lib'
/**
 *
 *
 * @export
 * @param {react Object} Layout - The Layout component
 * @returns {react Object} The returned component, according to the authentication of the token.
 */
export default function authenticate(Layout) {
  class LoadProfileDetails extends Component {
    // state = {
    //   reditectToRefferal: false
    // };
    async componentDidMount() {
      if (
        sessionStorage.getItem('authToken') ||
        localStorage.getItem('authToken')
      ) {
        const token = getToken()
        let res =  await this.props.checkValidity(token)
        if (res.errors) {
          console.error('token not valid')
          this.props.history.push('/login')
          // this.setState({ reditectToRefferal: true });
        } else {
          this.props.returnUserIfUserExists(token)

          if (res.data.current_user.fvlite_role != 'admin' && this.props.location.pathname.indexOf('/admin/users') > -1 ){
            this.props.history.push('/admin')
          }

          let expires_in = getExpiresIn(res.data.parent);
          let that = this;
          expires_in.then(function(expired_count){
            if(expired_count <= 0 && that.props.location.pathname != '/admin/settings/manage-plans/campaign') {
              that.props.history.push('/admin/settings/manage-plans')
            }
          })
        }
      }
    }
    async componentWillReceiveProps(nextProps) {
      if (nextProps.location.pathname !== this.props.location.pathname) {
        if (
          sessionStorage.getItem('authToken') ||
          localStorage.getItem('authToken')
        ) {
          const token = getToken()
          let res = await this.props.checkTokenOnPathChange(token)
          if (res.errors) {
            console.error('token not valid in here')
            this.props.history.push('/login')
          } else {
            if (res.data.current_user.fvlite_role != 'admin' && this.props.location.pathname.indexOf('/admin/users') > -1 ){
              this.props.history.push('/admin')
            }
            let expires_in = getExpiresIn(res.data.parent);
            let that = this;
            expires_in.then(function(expired_count){
              if(expired_count <= 0 && that.props.location.pathname != '/admin/settings/manage-plans/campaign') {
                that.props.history.push('/admin/settings/manage-plans')
              }
            })
          }
        }
      }
    }

    render() {
      return <Layout {...this.props} />
    }
  }

  return LoadProfileDetails
}

export function checkIftokenExists(Layout) {
  class RedirectIfLoggedIn extends Component {
    componentDidMount() {
      if (
        sessionStorage.getItem('authToken') ||
        localStorage.getItem('authToken')
      ) {
        const token = getToken()
        this.props.checkValidity(token).then(res => {
          if (!res.errors) {
            this.props.history.push('/')
          } else {
            console.error('token not valid in logged out')
            this.props.recieveLoginstatus(false, {})
            sessionStorage.removeItem('authToken')
            localStorage.removeItem('authToken')
          }
        })
      }
    }

    render() {
      return <Layout {...this.props} />
    }
  }

  return RedirectIfLoggedIn
}



// WEBPACK FOOTER //
// src/layouts/authenticateHOC.js